import { BaseSyntheticEvent, FC, useEffect, useState } from 'react'
import { Input } from '../Input/Input'
import Swal from 'sweetalert2'
import { LittleButton } from '../Button/LittleButton'
import usePluginsSpace from '../../hooks/usePluginSpace'
import { ModalWrapper } from '../Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../hooks/useModals'
import { Loading } from '../../components/Loading/Loading'
import { CardImageProduct } from './CardImageProduct'
import { ImageLoadingOverlay } from './ImageLoadingOverlay'
import { CardImageStore } from './CardImageStore'

type Props = {
  next: () => void
  back: () => void
  data: any
  setData: (value: any) => any
}

type Image = {
  image: string | File
}

export type CardProduct = {
  image?: File | null | string | undefined
  value?: string
  description?: string
  urlExternal?: string
}

type ImageLoadingState = {
  principal: boolean
  card1: boolean
  card2: boolean
  card3: boolean
  card4: boolean
  card5: boolean
  product0: boolean
  product1: boolean
  product2: boolean
  product3: boolean
  product4: boolean
}

const ImagensLoja: FC<Props> = ({ next, back, data, setData }) => {
  const [imagePricipal, setImagePrincipal] = useState<File | null | string>()
  const [cardsProduct, setCardsProduct] = useState<CardProduct[]>([])
  const [imagesStore, setImagesStore] = useState<Image[]>([])


  const { pluginSpace } = usePluginsSpace()

  const [hasProductCard, setHasProductCard] = useState<boolean>(false)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [imageLoadingState, setImageLoadingState] = useState<ImageLoadingState>({
    principal: false,
    card1: false,
    card2: false,
    card3: false,
    card4: false,
    card5: false,
    product0: false,
    product1: false,
    product2: false,
    product3: false,
    product4: false,
  })

  // Função para atualizar estado de loading de uma imagem
  const setImageLoading = (imageKey: keyof ImageLoadingState, isLoading: boolean) => {
    setImageLoadingState(prev => ({
      ...prev,
      [imageKey]: isLoading
    }))
  }

  function showImages() {
    try {
      // Definir todas como carregando inicialmente
      setImageLoadingState({
        principal: true,
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        product0: true,
        product1: true,
        product2: true,
        product3: true,
        product4: true,
      })

      if (data.config.images) {
        Array(5).fill(null).forEach((_, index) => {
          if (!data.config.images[index] || !data.config.images[index].image) {
            data.config.images[index] = { image: '' }
          }
        })
        setImagesStore(data.config.images)
      }

      if (data.config.product) {
        Array(5).fill(null).forEach((_, index) => {
          if (!data.config.product[index]) {
            data.config.product[index] = {
              image: '',
              value: '',
              description: '',
            }
          }
        })

        setCardsProduct(data.config.product)
      }

      setImagePrincipal(data.image)

      if (pluginSpace && pluginSpace.detail && pluginSpace.detail.theme === 2) {
        setHasProductCard(true)
      }

      // Simular carregamento das imagens (em casos reais, isso é feito pelo onLoad do img)
      setTimeout(() => {
        setImageLoadingState({
          principal: false,
          card1: false,
          card2: false,
          card3: false,
          card4: false,
          card5: false,
          product0: false,
          product1: false,
          product2: false,
          product3: false,
          product4: false,
        })
      }, 1000)
    } catch (error) {
      console.log(error)
      // Desligar loading em caso de erro
      setImageLoadingState({
        principal: false,
        card1: false,
        card2: false,
        card3: false,
        card4: false,
        card5: false,
        product0: false,
        product1: false,
        product2: false,
        product3: false,
        product4: false,
      })
    }
  }

  function nextPage() {
    const hasMinimumRequiredImages = imagesStore.filter(image => image.image).length >= 3
    if (
      !imagePricipal || !hasMinimumRequiredImages
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Verifique os campos faltantes',
      })
      return
    }
    const newData = data

    newData.config.images = imagesStore
    newData.config.product = cardsProduct
    newData.image = imagePricipal

    setData(newData)
    next()
  }

  function backPage() {
    const newData = data
    newData.config.images = imagesStore
    newData.image = imagePricipal
    newData.config.product = cardsProduct
    setData(newData)
    back()
  }

  useEffect(() => {
    showImages()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <div className='card mt-5' style={{ padding: '2rem 5rem' }}>
      <div>
        <h3>Imagens da Loja </h3>
        <span>Aqui você configura as imagens da loja .</span>
      </div>

      <div className='row ' style={{ marginTop: '14px' }}>
        <div className='col-2 d-flex flex-column border-end' style={{ gap: '16px' }}>
          <span
            style={{
              color: '#677484',
              fontWeight: '600',
            }}
          >
            Imagem - Card da Loja
          </span>
          <div style={{ position: 'relative' }}>
            <Input
              inputAttr={{
                type: 'image',
              }}
              imagemBackgroundDefault={'340x340'}
              width='100'
              height='100'
              value={imagePricipal}
              change={(value: BaseSyntheticEvent) => {
                const file = value ? value.target.files[0] : null;
                const sizeInBytes: number = file ? file.size : 0;

                const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                if (sizeInMB > 2) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                  });
                  return;
                }

                setImageLoading('principal', true)
                setImagePrincipal(value ? value.target.files[0] : null)
                setTimeout(() => setImageLoading('principal', false), 500)
              }}
            />
            <ImageLoadingOverlay isLoading={imageLoadingState.principal} />
          </div>
        </div>

        <div className='col-7 d-flex flex-column' style={{ gap: '16px' }}>
          <span
            style={{
              color: '#677484',
              fontWeight: '600',
            }}
          >
            Imagem - Card da Loja
          </span>

          <div className='d-flex gap-5 justify-content-center flex-wrap'>

            {imagesStore.map((image, index) => (
              <CardImageStore
                imagem={image}
                key={`store-${index}`}
                isLoading={imageLoadingState[`card${index + 1}` as keyof ImageLoadingState]}
                saveImage={(updatedImage) => {
                  const updatedImages = [...imagesStore]
                  updatedImages[index] = updatedImage
                  setImagesStore(updatedImages)
                }}
              />))}
          </div>
        </div>
        <div className='col-3 d-flex flex-column justify-content-between'>
          <div className='position-relative'>
            {!hasProductCard && (
              <div
                className='position-absolute w-100 h-100'
                style={{
                  zIndex: 9999,
                  background: 'rgba(250,250,250,0.6)',
                }}
              ></div>
            )}
            <span
              style={{
                color: '#677484',
                fontWeight: '600',
              }}
            >
              Imagem - Card do Produto
            </span>
            <div className='d-flex gap-5 justify-content-center flex-wrap'>
              {cardsProduct.map((card, index) => (
                <CardImageProduct
                  cardProduct={card}
                  key={`product-${index}`}
                  hasProductCard={hasProductCard}
                  isLoading={imageLoadingState[`product${index}` as keyof ImageLoadingState]}
                  saveProductCard={(updatedCardProduct) => {
                    const updatedCards = [...cardsProduct]
                    updatedCards[index] = updatedCardProduct
                    setCardsProduct(updatedCards)
                  }}
                />
              ))}
            </div>
          </div>


        </div>
        <div className='d-flex  gap-5 justify-content-between mt-5'>
          <LittleButton
            text={'voltar'}
            color={'info'}
            click={() => backPage()}
            width='110px'
            height='35px'
          />

          <LittleButton
            text={'Próximo'}
            color={'primary'}
            click={() => nextPage()}
            width='110px'
            height='35px'
          />
        </div>
      </div>
    </div>
  )
}

export { ImagensLoja }
